<template>
  <a-spin :spinning="confirmLoading">
    <div class="driver-form-box" :style="{height:height+'px'}">
        <j-form-container >
          <a-form :form="form" slot="detail">
            <j-alert ref="alert"/>
            <div class="driver-new-box">
               <div class="driver-new-box-left" :style="{height:height+'px'}">
                 <div>
                 <div style="margin-bottom: 10px" class="font-16">头像照片</div>
                   <a-col :span="24"  @mouseover="hoverSpace(0)">
                   <a-form-item  :labelCol="labelCol" :wrapperCol="wrapperCol">
                   <j-image-upload-new  :disabled="disabled" :number="3"  bizPath="headImg"  :width="240" :height="150"  @getImgState="getImgState" v-decorator="['headImg', validatorRules.headImg]" url="https://www.surely.cool/surely-vue-logo.png" @change="checkChange('headImg')"></j-image-upload-new>
                   </a-form-item>
                   </a-col>
                 </div>
                 <div>
                   <div style="margin-bottom: 10px" class="font-16">身份证（正面）</div>
                   <a-col :span="24"  @mouseover="hoverSpace(318)">
                   <a-form-item  :labelCol="labelCol" :wrapperCol="wrapperCol">
                   <j-image-upload-new  :disabled="disabled" @change="checkChange('idCardFront')" :number="3" :width="240" :height="150"   bizPath="idCardFront"  :scan="disabled?'':'idCard'" @scanOk="getOcrInfo" @getImgState="getImgState"   v-decorator="['idCardFront', validatorRules.idCardFront]" ></j-image-upload-new>
                   </a-form-item>
                   </a-col>
                 </div>
                 <div>
                   <div style="margin-bottom: 10px;" class="font-16">身份证（背面）</div>
                   <a-col :span="24"  @mouseover="hoverSpace(318)">
                   <a-form-item  :labelCol="labelCol" :wrapperCol="wrapperCol">
                   <j-image-upload-new  :number="3" :width="240" :height="150"  :disabled="disabled" @change="checkChange('idCardBack')"  bizPath="idCardBack"  @getImgState="getImgState"   v-decorator="['idCardBack', validatorRules.idCardBack]" ></j-image-upload-new>
                   </a-form-item>
                   </a-col>
                 </div>
                 <div>
                   <div style="margin-bottom: 10px" class="font-16">驾驶证正本</div>
                   <a-col :span="24"  @mouseover="hoverSpace(1166)">
                   <a-form-item  :labelCol="labelCol" :wrapperCol="wrapperCol">
                   <j-image-upload-new  :number="3" :width="240" :height="150"  :disabled="disabled"    @change="checkChange('licenseFrontImg')"  bizPath="licenseFrontImg" :scan="disabled?'':'driverLicense'" @scanOk="getOcrInfo"   @getImgState="getImgState"   v-decorator="['licenseFrontImg', validatorRules.licenseFrontImg]" ></j-image-upload-new>
                   </a-form-item>
                   </a-col>
                 </div>
                 <div>
                  <div style="margin-bottom: 10px" class="font-16">驾驶证副本</div>
                   <a-col :span="24"   @mouseover="hoverSpace(1166)">
                   <a-form-item  :labelCol="labelCol" :wrapperCol="wrapperCol">
                   <j-image-upload-new  :number="3" :width="240" :height="150"  :disabled="disabled"    @change="checkChange('licenseBackImg')"  bizPath="licenseBackImg"  @getImgState="getImgState"   v-decorator="['licenseBackImg', validatorRules.licenseBackImg]" ></j-image-upload-new>
                   </a-form-item>
                   </a-col>
                 </div>
                 <div>
                   <div style="margin-bottom: 10px" class="font-16">人证信息</div>
                   <a-col :span="24"    @mouseover="hoverSpace(1696)">
                   <a-form-item  :labelCol="labelCol" :wrapperCol="wrapperCol">
                   <j-image-upload-new  :number="3" :width="240" :height="150"  @change="checkChange('personLicenseImg')" :disabled="disabled"  bizPath="personLicenseImg"  @getImgState="getImgState"    v-decorator="['personLicenseImg', validatorRules.personLicenseImg]" ></j-image-upload-new>
                   </a-form-item>
                   </a-col>
                 </div>
               </div>
              <div class="driver-new-box-right" ref="scrollRight"  :style="{height:(height-24)+'px'}">
                <div>
                  <a-col :span="24">
                    <div class="driver-label-title font-16">所属城市</div>
                    <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-tree-select
                        v-decorator="['areaName', validatorRules.areaName]"
                        show-search
                        :disabled="disabled"
                        style="width: 100%"
                        :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                        :tree-data="cityList"
                        placeholder="请选择城市"
                        allow-clear
                        tree-default-expand-all
                        @change="checkChange('areaName')"
                      >
                      </a-tree-select>
                      <a class="input-a select-a"  id="fareaName" :data-clipboard-text="model.areaName" v-if="disabled&&driverId && (hoverStr==('areaName'+model.id))" @click="viewPhone('fareaName')">点击复制</a>
                    </a-form-item>
                  </a-col>
                  <a-col :span="24">
                  <div class="driver-label-title font-16 margin-top-2">手机号</div>
                  <a-form-item  label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input-group compact>
                      <a-input  :disabled="disabled || (model.id && model.id.length>0)" :style="{'width':(disabled?'100%':'87%')}" @mouseover="hoverA(model.phone,model.id)" @mouseleave="unHoverA('fphone')"  style="position: relative"    @change="checkChange('phone')"  v-decorator="['phone', validatorRules.phone]" :placeholder="disabled?'':'请输入手机号'"  >
                      </a-input>
                      <a class="input-a" id="fphone" :data-clipboard-text="model.phone" v-if="disabled&&driverId && (hoverStr==model.phone+''+model.id)" @click="viewPhone('fphone')">点击复制</a>
                      <a-button type="link" @click="addPhone" v-if="!disabled&&phoneList.length<200" class="op-phone plus" icon="plus"></a-button>
                    </a-input-group>

                  </a-form-item>
                  </a-col>
                  <a-col :span="24" v-for="(item,idx) in phoneList">
                    <div class="driver-label-title font-16 margin-top-2" >手机号</div>
                    <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input-group compact>
                        <a-input :disabled="disabled || item.isEdit"  @mouseover="hoverA(model['phone'+(idx+2)],model.id)" @mouseleave="unHoverA('fphone'+(idx+2))"   @change="checkChange('phone'+(idx+2))"  :style="{'width':(disabled?'100%':'87%')}"  style="position: relative" v-decorator="['phone'+(idx+2), validatorRules['phone'+(idx+2)]]"   :placeholder="disabled?'':'请输入手机号'+(idx+2)"  ></a-input>
                        <a class="input-a" :id="'fphone'+(idx+2)" :data-clipboard-text="model['phone'+(idx+2)]" v-if="disabled&&driverId && (hoverStr==model['phone'+(idx+2)]+''+model.id)" @click="viewPhone('fphone'+(idx+2))">点击复制</a>
                        <a-button v-if="!disabled" type="link" @click="miusPhone(idx)" class="op-phone minus" icon="minus"></a-button>
                      </a-input-group>
                    </a-form-item>
                  </a-col>
                </div>
                <div>
                <a-col  :span="24">
                  <div class="driver-label-title font-16">姓名</div>
                  <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input  :disabled="disabled"  v-decorator="['driverName', validatorRules.driverName]"  @mouseover="hoverA('driverName',model.id)" @mouseleave="unHoverA('fdriverName')" :placeholder="disabled?'':'请输入客户姓名'"   @change="checkChange('driverName')"></a-input>
                  <a class="input-a"  id="fdriverName" :data-clipboard-text="model.driverName" v-if="disabled&&driverId && (hoverStr=='driverName'+model.id)" @click="viewPhone('fdriverName')">点击复制</a>
                  </a-form-item>
                  </a-col>
                  <a-col :span="24">
                  <div class="driver-label-title font-16 margin-top-2">身份证号码</div>
                  <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input :disabled="checkIdNumberDisable()" @blur="formatIdNumber"  @change="checkChange('idNumber')"   @mouseover="hoverA('idNumber',model.id)" @mouseleave="unHoverA('fidNumber')" v-decorator="['idNumber', validatorRules.idNumber]" :placeholder="disabled?'':'请输入身份证号码'"  ></a-input>
                  <a class="input-a"  id="fidNumber" :data-clipboard-text="model.idNumber" v-if="disabled&&driverId && (hoverStr=='idNumber'+model.id)" @click="viewPhone('fidNumber')">点击复制</a>
                  </a-form-item>
               </a-col>
                <a-col :span="24">
                  <div class="driver-label-title font-16 margin-top-2">出生年月</div>
                  <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <j-date :disabled="disabled"  @change="checkChange('birthDate')" :placeholder="disabled?'':'请选择出生年月'" v-decorator="['birthDate']"  @mouseover="hoverA('birthDate',model.id)" @mouseleave="unHoverA('fbirthDate')" :trigger-change="true" style="width: 100%" />
                  <a class="input-a"  id="fbirthDate" :data-clipboard-text="model.birthDate" v-if="disabled&&driverId && (hoverStr=='birthDate'+model.id)" @click="viewPhone('fbirthDate')">点击复制</a>
                  </a-form-item>
                  </a-col>
                  <a-col :span="24">
                  <div class="driver-label-title font-16 margin-top-2">户口地址</div>
                  <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input :disabled="disabled"  @change="checkChange('accountAddress')" v-decorator="['accountAddress']" :placeholder="disabled?'':'请输入户口地址'"  @mouseover="hoverA('accountAddress',model.id)" @mouseleave="unHoverA('faccountAddress')" ></a-input>
                  <a class="input-a"  id="faccountAddress" :data-clipboard-text="model.accountAddress" v-if="disabled&&driverId && (hoverStr=='accountAddress'+model.id)" @click="viewPhone('faccountAddress')">点击复制</a>
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <div class="driver-label-title font-16 margin-top-2">民族</div>
                  <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input :disabled="disabled"  @change="checkChange('nation')"   @mouseover="hoverA('nation',model.id)" @mouseleave="unHoverA('fnation')" v-decorator="['nation']" :placeholder="disabled?'':'请输入民族'"  ></a-input>
                  <a class="input-a"  id="fnation" :data-clipboard-text="model.nation" v-if="disabled&&driverId && (hoverStr=='nation'+model.id)" @click="viewPhone('fnation')">点击复制</a>
                  </a-form-item>
                  </a-col>
                  <a-col :span="24">
                  <div class="driver-label-title font-16 margin-top-2">发证机关</div>
                  <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input :disabled="disabled"  @change="checkChange('licenceIssuing')"   @mouseover="hoverA('licenceIssuing',model.id)" @mouseleave="unHoverA('flicenceIssuing')" v-decorator="['licenceIssuing']" :placeholder="disabled?'':'请输入发证机关'"  ></a-input>
                  <a class="input-a"  id="flicenceIssuing" :data-clipboard-text="model.licenceIssuing" v-if="disabled&&driverId && (hoverStr=='licenceIssuing'+model.id)" @click="viewPhone('flicenceIssuing')">点击复制</a>
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <div class="driver-label-title font-16 margin-top-2">身份证开始日期</div>
                  <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <j-date :disabled="disabled"  @change="checkChange('cardBeginTime')" @mouseover="hoverA('cardBeginTime',model.id)" @mouseleave="unHoverA('fcardBeginTime')" :placeholder="disabled?'':'请选择身份证开始日期'" v-decorator="['cardBeginTime']" :trigger-change="true" style="width: 100%" />
                  <a class="input-a"  id="fcardBeginTime" :data-clipboard-text="model.cardBeginTime" v-if="disabled&&driverId && (hoverStr=='cardBeginTime'+model.id)" @click="viewPhone('fcardBeginTime')">点击复制</a>
                  </a-form-item>
                  </a-col>
                  <a-col :span="24">
                  <div class="driver-label-title font-16 margin-top-2">身份证截止日期</div>
                  <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <j-date :disabled="disabled"  @change="checkChange('cardEndTime')"   @mouseover="hoverA('cardEndTime',model.id)" @mouseleave="unHoverA('fcardEndTime')" :placeholder="disabled?'':'请选择身份证截止日期'" v-decorator="['cardEndTime']" :trigger-change="true" style="width: 100%" />
                  <a class="input-a"  id="fcardEndTime" :data-clipboard-text="model.cardEndTime" v-if="disabled&&driverId && (hoverStr=='cardEndTime'+model.id)" @click="viewPhone('fcardEndTime')">点击复制</a>
                  </a-form-item>
                </a-col>
                </div>
                <div class="driver-card-right">
                  <a-col :span="24">
                    <div class="driver-label-title font-16">驾驶证号</div>
                    <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input  :disabled="disabled" @change="checkChange('licenseNo')"   @mouseover="hoverA('licenseNo',model.id)" @mouseleave="unHoverA('flicenseNo')" v-decorator="['licenseNo']" :placeholder="disabled?'':'请输入驾驶证号'"  ></a-input>
                    <a class="input-a"  id="flicenseNo" :data-clipboard-text="model.licenseNo" v-if="disabled&&driverId && (hoverStr=='licenseNo'+model.id)" @click="viewPhone('flicenseNo')">点击复制</a>
                    </a-form-item>
                  </a-col>
                  <a-col :span="24">
                    <div class="driver-label-title font-16 margin-top-2">准驾车型</div>
                    <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <j-dict-select-tag
                      :disabled="disabled"
                      @change="checkChange('quasiDrivingVehicle')"
                      @mouseover="hoverA('quasiDrivingVehicle',model.id)"
                      @mouseleave="unHoverA('fquasiDrivingVehicle')"
                      type="list"
                      v-decorator="['quasiDrivingVehicle', validatorRules.quasiDrivingVehicle]"
                      :trigger-change="true"
                      dictCode="quasi_driving_vehicle" :placeholder="disabled?'':'请选择准驾车型'" />
                    <a class="input-a select-a" style="right: 8px;bottom: 2px"  id="fquasiDrivingVehicle" :data-clipboard-text="model.quasiDrivingVehicle" v-if="disabled&&driverId && (hoverStr=='quasiDrivingVehicle'+model.id)" @click="viewPhone('fquasiDrivingVehicle')">点击复制</a>
                    </a-form-item>
                  </a-col>
                  <a-col :span="24">
                    <div class="driver-label-title font-16 margin-top-2">初次领证日期</div>
                    <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <j-date  :disabled="disabled" @change="checkChange('firstReviceDate')"   @mouseover="hoverA('firstReviceDate',model.id)" @mouseleave="unHoverA('ffirstReviceDate')" :placeholder="disabled?'':'请选择初次领证日期'" v-decorator="['firstReviceDate']" :trigger-change="true" style="width: 100%" />
                    <a class="input-a"  id="ffirstReviceDate" :data-clipboard-text="model.firstReviceDate" v-if="disabled&&driverId && (hoverStr=='firstReviceDate'+model.id)" @click="viewPhone('ffirstReviceDate')">点击复制</a>
                    </a-form-item>
                  </a-col>
                  <a-col :span="24">
                    <div class="driver-label-title font-16 margin-top-2">驾驶证有效期起</div>
                    <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <j-date  :disabled="disabled" @change="checkChange('beginTime')"   @mouseover="hoverA('beginTime',model.id)" @mouseleave="unHoverA('fbeginTime')" :placeholder="disabled?'':'请选择驾驶证有效期起'" v-decorator="['beginTime']" :trigger-change="true" style="width: 100%" />
                    <a class="input-a"  id="fbeginTime" :data-clipboard-text="model.beginTime" v-if="disabled&&driverId && (hoverStr=='beginTime'+model.id)" @click="viewPhone('fbeginTime')">点击复制</a>
                    </a-form-item>
                  </a-col>
                  <a-col :span="24">
                    <div class="driver-label-title font-16 margin-top-2">驾驶证有效期止</div>
                    <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <j-date  :disabled="disabled" @change="checkChange('endTime')"   @mouseover="hoverA('endTime',model.id)" @mouseleave="unHoverA('fendTime')" :placeholder="disabled?'':'请选择驾驶证有效期止'" v-decorator="['endTime']" :trigger-change="true" style="width: 100%" />
                    <a class="input-a"  id="fendTime" :data-clipboard-text="model.endTime" v-if="disabled&&driverId && (hoverStr=='endTime'+model.id)" @click="viewPhone('fendTime')">点击复制</a>
                    </a-form-item>
                  </a-col>
                </div>
                <div>
                  <a-col :span="24">
                    <div class="driver-label-title font-16 ">人证核验</div>
                    <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <j-dict-select-tag   :disabled="disabled" @change="checkChange('licenseFlag')"  @mouseover="hoverA('licenseFlag',model.id)" @mouseleave="unHoverA('flicenseFlag')" type="list"  v-decorator="['licenseFlag', validatorRules.licenseFlag]" :trigger-change="true" dictCode="persona_license_flag" :placeholder="disabled?'':'请选择人证核验'" />
                    <a class="input-a select-a" style="right: 8px;bottom: 2px"  id="flicenseFlag" :data-clipboard-text="model.licenseFlag" v-if="disabled&&driverId && (hoverStr=='licenseFlag'+model.id)" @click="viewPhone('flicenseFlag')">点击复制</a>
                    </a-form-item>
                  </a-col>
                  <a-col :span="24">
                    <div class="driver-label-title font-16 margin-top-2">人证编号</div>
                    <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input  :disabled="disabled"   @change="checkChange('personLicenseNo')"   @mouseover="hoverA('personLicenseNo',model.id)" @mouseleave="unHoverA('fpersonLicenseNo')" v-decorator="['personLicenseNo']" :placeholder="disabled?'':'请输入人证编号'"  ></a-input>
                    <a class="input-a" id="fpersonLicenseNo" :data-clipboard-text="model.personLicenseNo" v-if="disabled&&driverId && (hoverStr=='personLicenseNo'+model.id)" @click="viewPhone('fpersonLicenseNo')">点击复制</a>
                    </a-form-item>
                  </a-col>

                </div>
              </div>
            </div>
            <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel()">
              <img alt="example" style="width: 100%" :src="previewImage"/>
            </a-modal>
          </a-form>
        </j-form-container>
    </div>

  <add-share-list ref="addShare" @ok="getInfo"></add-share-list>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue,by_str } from '@/utils/util'
  import Clipboard from 'clipboard'
  import AddShareList from ".//AddShareList";
  import { mapGetters } from 'vuex'
  export default {
    name: 'DmDriverModalForm',
    inject:["closeCurrent"],
    components: {
      AddShareList
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        height:document.documentElement.clientHeight-276,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          driverName: {
            rules: [
              { required: true, message: '请输入客户姓名!'},
            ]
          },
          idNumber: {
            rules: [
              { required: false},
              {validator:this.checkIdNumber}
            ]
          },
          phone: {
            rules: [
              { required: true, message: '请输入手机号码!'},
              {validator:this.checkPhone}
            ]
          },phone2: {
            rules: [
              { required: false},
              {validator:this.checkPhone}
            ]
          },phone3: {
            rules: [
              { required: false},
              {validator:this.checkPhone}
            ]
          },

        },
        url: {
          add: "/dm/dmDriver/add",
          edit: "/dm/dmDriver/edit",
          queryById: "/dm/dmDriver/queryById",
          queryByIdEdit: "/dm/dmDriver/queryByIdEdit"
        },phoneList:[],
        driverId:"",
        previewVisible:false,
        previewImage:"",
        uploadNum:0,
        workbenchBorder:false,
        toggle:{
          idcard:true,
          carId:true,
          person:true,
          enclosure:true
        },
        hoverStr:'',
        cityList:[],
        submitFlag:false,
        coloum:['driverName','headImg','idNumber','birthDate','accountAddress','nation','licenceIssuing','cardBeginTime','idCardFront','idCardBack','cardEndTime','phone','phone2','phone3',
          'licenseBackImg','licenseFrontImg','licenseNo','licenseFlag','quasiDrivingVehicle','firstReviceDate','beginTime','endTime','driverLabel','areaName',
          'personLicenseImg','personLicenseNo'],
        defaultModel:{}
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      //this.edit();
      this.getCityList();
    },
    methods: {
      ...mapGetters(["userInfo"]),
      add (record) {
        if(!this.formData){
          this.formData= {}
        }
        if(record&&record.phone){
          this.formData.phone = record.phone
        }

        if(!record.id && !this.formData.areaName){
          this.formData.areaName = this.userInfo().defaultArea;
        }
        this.height += 60
        this.edit();
      },show(){
        this.visible = true;

      },
      edit () {
        this.toTop();
        this.submitFlag = false;
        let record = this.formData;
        if(!this.formData.areaName){
          this.formData.areaName = this.userInfo().defaultArea;
        }
        this.phoneList = [];
        if(record.id){
          this.driverId = record.id;
          if(record.phoneStr){
            let phoneList = record.phoneStr.split(",");
            if(phoneList.length>1){
              for(var k in phoneList){
                if(k>0){
                  record['phone'+(parseInt(k)+1)]= phoneList[k];
                  this.phoneList.push({
                    phone:phoneList[k],
                    isEdit:1
                  });
                  if(!this.validatorRules['phone'+(parseInt(k)+1)]){
                    this.validatorRules['phone'+(parseInt(k)+1)] =  {
                      rules: [
                        { required: false},
                        {validator:this.checkPhone}
                      ]
                    }
                  }
                  if(this.coloum.indexOf('phone'+(parseInt(k)+1))==-1){
                    this.coloum.push('phone'+(parseInt(k)+1))
                  }
                }else{
                  record.phone = phoneList[k];
                }
              }
            }
          }

        }else{
          this.driverId = "";
        }

        this.form.resetFields();
        // if(record.license){
        //   record.licenseFrontImg =   record.license.frontImg;
        //   record.licenseBackImg =   record.license.backImg;
        //   record.licenseNo =   record.license.licenseNo;
        //   record.quasiDrivingVehicle =   record.license.quasiDrivingVehicle;
        //   record.firstReviceDate =   record.license.firstReviceDate;
        //   record.beginTime =   record.license.beginTime;
        //   record.endTime =   record.license.endTime;
        // }
        //
        // if(record.personLicense){
        //   record.personalLicenseImg =   record.personLicense.licenseImg;
        //   record.personalLicenseNo =   record.personLicense.licenseNo;
        //   record.licenseFlag = record.personLicense.licenseFlag;
        // }
        if(!(record.enclosureList&&record.enclosureList.length)){
          record.enclosureList = []
          record.enclosureList.push({
            imgPath:'',
            remark:""
          });
        }
        this.defaultModel = record
        this.model = Object.assign({}, record);
        this.visible = true;

        this.$nextTick(() => {

          this.form.setFieldsValue(pick(this.model,this.coloum))
        })

      },toTop(){

        this.$nextTick(() => {
          let scrollElem = this.$refs.scrollDiv;
          if(scrollElem)
          scrollElem.scrollTo({ top: 0, behavior: 'smooth' });
        });
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm (activeKey) {
        this.submitFlag = true
        const that = this;
        // 触发表单验证

        this.form.validateFields((err, values) => {
          console.log(err)
          if (!err) {
            if(activeKey){
              that.$emit('switchActive',activeKey);
              return;
            }
            //that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            let formData = Object.assign(this.model, values);
            let subPhone = formData.phone;
            if(that.phoneList && that.phoneList.length){
              let repeatMap = {};
              for(let p in that.phoneList){
                let phone = formData['phone'+(parseInt(p)+2)];
                if(!repeatMap[phone]){
                  repeatMap[phone] = 1;
                }else{
                  repeatMap[phone] = repeatMap[phone]+1;
                }
                subPhone = subPhone + ","+phone;
              }

              for(let a in repeatMap){
                console.log(repeatMap[a])
                if(repeatMap[a]>1){
                  that.$message.warning("不能输入相同的手机号");
                  that.confirmLoading = false;
                  return;
                }
              }
               this.submitFlag = false;
            }
            formData.phone =  subPhone
           /* if(formData.phone2&&that.phoneList.length>0){
              if(formData.phone.indexOf(formData.phone2)!=-1){
                that.$message.warning("不能输入相同的手机号");
                that.confirmLoading = false;
                return;
              }else{
                this.submitFlag = false;
              }
              formData.phone = formData.phone + ","+formData.phone2;
            }
            if(formData.phone3&&that.phoneList.length>1){
              if(formData.phone.indexOf(formData.phone3)!=-1){
                that.$message.warning("不能输入相同的手机号");
                that.confirmLoading = false;
                return;
              }else{
                this.submitFlag = false;
              }
              formData.phone = formData.phone + ","+formData.phone3;
            }*/


            /*formData.license = {
              frontImg:formData.frontImg,
              backImg:formData.backImg,
              licenseNo:formData.licenseNo,
              quasiDrivingVehicle:formData.quasiDrivingVehicle,
              firstReviceDate:formData.firstReviceDate,
              beginTime:formData.beginTime,
              endTime:formData.endTime,

            }*/
            // formData.licenseFrontImg =   formData.frontImg;
            // formData.licenseBackImg =   formData.backImg;



            formData.personLicense = {
              licenseImg:formData.personLicenseImg,
              licenseNo:formData.personLicenseNo,
              licenseFlag:formData.licenseFlag
            }
            if(this.model.license){
              formData.license.id=this.model.license.id
            }
            if(this.model.personLicense){
              formData.personLicense.id=this.model.personLicense.id
            }
            if(this.model.enclosureList && this.model.enclosureList.length){
              formData.enclosureList = this.model.enclosureList
              if(this.model.id){
                for(let a in formData.enclosureList){
                  formData.enclosureList[a].driverId = this.model.id
                }
              }

            }
            that.$emit('getData',formData);
          }else{
            this.submitFlag = false;
          }

        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,this.coloum))
      },close(){
        this.closeCurrent();
      },addPhone(){
        if(this.phoneList.length<200){
          this.phoneList.push({
            phone:''
          })

          if(!this.validatorRules['phone'+(this.phoneList.length+1)]){
            this.validatorRules['phone'+(this.phoneList.length+1)] =  {
              rules: [
                { required: false},
                {validator:this.checkPhone}
              ]
            }
          }
          if(this.coloum.indexOf('phone'+(this.phoneList.length+1))==-1){
            this.coloum.push('phone'+(this.phoneList.length+1))
          }


          this.$nextTick(() => {
            this.form.setFieldsValue(pick(this.model,'phone'+(this.phoneList.length+1)))
            this.form.validateFields();
          })
        }
        this.checkChange("",true);
       //
      },miusPhone(idx){
        if(this.phoneList[idx]){
          this.phoneList.splice(idx,1);
          for(let a in this.phoneList){
            let i = parseInt(a)+2
              this.model['phone'+i] = this.phoneList[a].phone;
              this.$nextTick(() => {
                this.form.setFieldsValue(pick(this.model,'phone'+i))
                this.form.validateFields();
              })
          }

          console.log("this.model",this.model)
          this.checkChange("",true);
        }
      },setDefault(phone){
        let phoneList = this.phoneList;
        let zh = this.form.getFieldValue("phone");

        for(let a in phoneList){
          if(phoneList[a].phone==phone){
            phoneList[a].phone = zh;
            this.model['phone'+(parseInt(a)+2)] = zh;

          }
        }
        this.model.phone = phone

        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'phone','phone2','phone3'))
          this.form.validateFields();
        })
      },
      handleCancel() {
        this.previewVisible = false;
      },getOcrInfo(ocrInfo){
        console.log(ocrInfo)
        if(ocrInfo){
          if(ocrInfo.name){
            this.model.driverName = ocrInfo.name
          }
          if(ocrInfo.address){
            this.model.accountAddress = ocrInfo.address
          }

          if(ocrInfo.idNo){
            if(!this.model.idNumber){
              this.model.idNumber = ocrInfo.idNo
            }else if(this.model.idNumber!=ocrInfo.idNo){
              this.$message.error('OCR识别身份证号与司机身份证号不一致!')
            }

          }
          if(ocrInfo.birth){
            this.model.birthDate = ocrInfo.birth
          }
          if(ocrInfo.nation){
            this.model.nation = ocrInfo.nation
          }

          if(ocrInfo.endTime){
            this.model.endTime = ocrInfo.endTime
          }
          if(ocrInfo.beginTime){
            this.model.beginTime = ocrInfo.beginTime
          }
          if(ocrInfo.licenseNo){
            this.model.licenseNo = ocrInfo.licenseNo
          }
          if(ocrInfo.quasiDrivingVehicle){
            this.model.quasiDrivingVehicle = ocrInfo.quasiDrivingVehicle
          }
          if(ocrInfo.firstReviceDate){
            this.model.firstReviceDate = ocrInfo.firstReviceDate
          }

          this.$nextTick(() => {
            this.form.setFieldsValue(pick(this.model,'driverName','idNumber','birthDate','accountAddress','nation',
            'firstReviceDate','quasiDrivingVehicle','licenseNo','licenseFlag','beginTime','endTime','personLicenseImg','personLicenseNo'))
            this.form.validateFields();
            this.checkChange();
          });

        }
      },getImgState(num){
        this.uploadNum += num;
        console.log("这个时候状态值为：",this.uploadNum)
      },checkPhone(rule, value, callback){
        let that = this;
        if(this.model.id&&value.indexOf("*")!=-1 && value.length==11){
          callback()
        }else{

          let regx = /^1[3456789]\d{9}$/;
          if(!regx.test(value)){
            callback("请输入正确的手机号!");
          }else{
            let formData = {
              num:value,
              type:1,
              id:this.driverId
            }
            getAction("/dm/dmDriver/queryByPhoneOrCard",formData).then((res)=>{
              if(res.success){
                if(!this.submitFlag && !this.model.id){
                  this.$refs.addShare.edit(this.model.id,res.result,value,1);
                }
                callback();
              }else{
                callback();
              }
            })
          }
        }


      },checkIdNumber(rule, value, callback){
        console.log(value)
        let that = this;
        if(value=='' || value== null || value==undefined){
          callback()
        }
        if(this.model.id&&value.indexOf("*")!=-1 && (value.length==15 || value.length==18)){
          callback()
        }else {
          let regx = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
          if (!regx.test(value)) {
            callback("请输入正确的身份证号!");
          } else {
            let formData = {
              num: value,
              type: 2,
              id: this.driverId
            }
            getAction("/dm/dmDriver/queryByPhoneOrCard", formData).then((res) => {
              if (res.success) {
                this.$refs.addShare.edit(this.model.id,res.result,value,2);
              } else {
                callback();
              }
            })
          }

        }
      },viewPhone(id){

        let _this = this
        let clipborad = new Clipboard('#'+id);
        //复制成功
        clipborad.on('success', function() {
          _this.$message.success('复制成功！')
          clipborad.destroy();
        })
      },getInfo(driverId){
        this.$emit("getInfo",driverId)
      },applyShare(idNumber){
        let that = this;
        let formData = {
          "idNumber":idNumber
        }
        getAction("/dm/dmShareDriver/applyShare",formData).then((res)=>{
          if(res.success){
            if(res.message=="已存在共享人数据"){
              this.$confirm({
                title: '提示',
                okText: '立即查看',
                cancelText: '取消',
                content: '您已经是该司机的共享人了，是否去查看？',
                onOk: () => {
                  this.$emit("getInfo",res.result,true)
                },
                onCancel: () => {

                }
              })
            }else{
              that.$message.success("操作成功!");
              that.$emit("getInfo",res.result,true);
            }

          }else{
            that.$message.warning(res.message);
          }
        })
      },
       checkChange(colum,bo){
        this.$nextTick(()=>{
          let val = this.form.getFieldsValue();
          this.checkModelAndForm(val,bo)
          if(colum.indexOf("phone") !=-1 && colum!='phone'){
            let idx = parseInt(colum.substring(5))-2;
            this.phoneList[idx].phone = val[colum];
          }
        })


      },checkModelAndForm(values,bo){
        let chak = bo?bo:false;
        for(let a in values){
          if(values[a]!=this.defaultModel[a]){
            chak = true;
          }
        }

        console.log("chak",chak)
        this.$emit("hasChange",chak);
      },callPhone(phone){
        this.$refs.callRecord.edit(phone,this.model.id);
      },updateCallStatus(){
        window.workbench.driverId = this.model.id;
      },checkPosition(){

        this.form.validateFields((err, values) => {
          if(this.position=='left'){
            this.position='right'

          }else{
            this.position='left'
          }
          this.$nextTick(() => {
            this.form.setFieldsValue(pick(values,'driverName','headImg','idNumber','birthDate','accountAddress','nation','licenceIssuing','cardBeginTime','idCardFront','idCardBack','cardEndTime','phone','phone2','phone3',
              'frontImg','backImg','licenseFrontImg','licenseBackImg','licenseNo','quasiDrivingVehicle','licenseFlag','firstReviceDate','beginTime','endTime','driverLabel','areaName',
              'personLicenseImg','personLicenseNo'))
          })
          localStorage.setItem("fz_position",this.position)
        });


      },viewLog(){
        this.$refs.dmLog.edit({operateTypeQuery:"1,7,8",id:this.model.id});
      },formatIdNumber(val){
        let IDNumerical= val.target._value;
        if(IDNumerical.indexOf("x")!=-1){
          IDNumerical = IDNumerical.replace("x","X");
        }
        this.model.idNumber = IDNumerical;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'idNumber'))
        })
      },handleToggleSearch(val){
        this.toggle[val]= !this.toggle[val];
      },
      addEnclosure(){
        this.model.enclosureList.push({
          imgPath:'',
          remark:""
        })
      },removeEnclosure(idx){
        this.model.enclosureList.splice(idx,1);
      },hoverA(a,b){

        this.hoverStr = a+""+b;
      },unHoverA(id){
        if(!this.checkIn(document.getElementById(id))){
          this.hoverStr = ""
        }
      },
      // 判断鼠标是否落在一个块级元素内部
      checkIn(obj) {
        var x = Number(window.event.clientX) // 鼠标相对屏幕横坐标
        var y = Number(window.event.clientY) // 鼠标相对屏幕纵坐标

        var div_x = Number(obj.getBoundingClientRect().left) // obj相对屏幕的横坐标
        var div_x_width = Number(
          obj.getBoundingClientRect().left + obj.clientWidth
        ) // obj相对屏幕的横坐标+width

        var div_y = Number(obj.getBoundingClientRect().top) // obj相对屏幕的纵坐标
        var div_y_height = Number(
          obj.getBoundingClientRect().top + obj.clientHeight
        ) // obj相对屏幕的纵坐标+height

        if (x > div_x && x < div_x_width && y > div_y && y < div_y_height) {
          return true
        } else {
          return false
        }
      },getCityList(){
        getAction("/dm/dmArea/listCity").then((res)=>{
          if(res.success){
            let city = res.result;
            if(city){
              let cityMap ={};
              for(let a in city){
                if(!cityMap[city[a].areaPy]){
                  cityMap[city[a].areaPy] = [];
                }
                cityMap[city[a].areaPy].push(city[a]);
              }
              let cityList = [];
              for(let b in cityMap){
                cityList.push({
                  firstPinyin:b,
                  city:cityMap[b]
                })
              }

              cityList.sort(by_str("firstPinyin"));
              let treeData = [];
              for(let c in cityList){
                let obj = {
                  selectable:false,
                  key:cityList[c].firstPinyin,
                  title:cityList[c].firstPinyin,
                  value:cityList[c].firstPinyin,
                  children:[]
                }
                if(cityList[c].city){
                  for(let d in cityList[c].city){
                    obj.children.push({
                      key:cityList[c].city[d].areaName,
                      title:cityList[c].city[d].areaName,
                      value:cityList[c].city[d].areaName,
                      isLeaf:true
                    });
                  }
                }
                treeData.push(obj);
              }
              this.cityList = treeData;
            }
          }else{
          }
        })
      },checkIdNumberDisable(){
       if(this.disabled){
         return true;
       }
       if((this.defaultModel.id && this.defaultModel.idNumber&&(this.defaultModel.idNumber.length==15||this.defaultModel.idNumber.length==18))){
         return true;
       }
       return  false;
      },hoverSpace(top){
        //this.scrollToElement(top);
      }, scrollToElement(top) {
        const el =    this.$refs.scrollRight;
        console.log(el)
        if (el) {
          if(top>0 && this.phoneList.length){
            top += (this.phoneList.length-1) * 106;
          }
          el.scrollTo(0,top)
        }
      }

    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
  @import '~@assets/less/dm/form.less';

  /deep/ .imgupload .ant-upload-select{display:block}
  /deep/ .imgupload .ant-upload.ant-upload-select-picture-card{ width:316px;height: 176px;}
  /deep/ .imgupload .iconp{padding:64px;}
  /* update--end--autor:lvdandan-----date:20201016------for：j-image-upload图片组件单张图片详情回显空白*/
  .rt_edit{
    right: 40px;
  }
  .zh-btn{
    position: absolute;
    font-size: 14px;
    margin-left: 10px;
    line-height: 48px;
  }



  /deep/ .ant-col-sm-16{
    width: 100%;
  }
  /deep/ .ant-select-tree li .ant-select-tree-node-content-wrapper.ant-select-tree-node-selected{
    background: #1890ff !important;
    color: #fff;
  }



  /deep/ .ant-select-selection--single{
    height: 48px !important;
  }
  /deep/ .ant-select-selection__rendered{
    line-height: 48px !important;
  }
  /deep/ .ant-input{
    height: 48px !important;
  }
  /deep/ textarea.ant-input{
    height: auto !important;
  }
  /deep/ .op-phone.ant-btn{
    height: 42px !important;
    width: 42px !important;
    border-radius:12px !important;
  }



</style>